<template>
    <div class="float-left">
        <i
            class="fa fa-search-plus fa-lg icon-button"
            title="Documentos da Licitação"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">Documentos Da Licitação</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="16" md="6">
                        <b-form-group>
                            <label>
                                Número do Processo
                            </label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="licitacao.numeroProcesso"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="16" md="6">
                        <b-form-group>
                            <label>Objeto da Licitação</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="licitacao.objeto"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Documentos </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    :itens="documentosLicitacao"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false">
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <inserir-documentos
                                                class="mr-2"
                                                :licitacao="licitacao"
                                                @atualizarLista="obterDocumentos()">
                                            </inserir-documentos>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span
                                            class="text-danger float-left mr-1">
                                            <i
                                                class="fa fa-trash fa-lg icon-button"
                                                title="Excluir Documento"
                                                @click.stop="confirmarExcluirDocumento(data.idDocumento)"
                                            ></i>
                                        </span>
                                        <span
                                            class="text-success float-left mr-1">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download"
                                                @click.stop="confirmarDownload(data)"
                                            ></i>
                                        </span>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../../../fornecedor/ConvenioServicos'
import InserirDocumentos from './InserirDocumentos.vue';

export default {
    props: {
        convenio: Object,
        licitacao: Object

    },

    components: {
      InserirDocumentos
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: [],
            erros: [],
            documentosLicitacao:[],
            itensPorPagina: 5,
            documentosEvento: [],
            campos: [
                {
                    key: 'descricaoArquivo',
                    label: 'Nome do Arquivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        abrirModal() {
            if (!this.desativarBotao) {
                this.mostrarModal = true
                this.obterDocumentos()
            }
        },

        fecharModal() {
            this.mostrarModal = false
        },

        fecharModalImagem() {
            this.arquivo = null
        },

        confirmarExcluirDocumento(id) {
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir o Documento ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ExcluirDocumento(id)
                }
            })
        },

        ExcluirDocumento(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirDocumentoLicitacao(id).then(
                (response) => {
                    if (response) {
                        this.obterDocumentos()
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterDocumentos() {
           this.$store.dispatch('addRequest')
            ConveniosServicos.obterDocumentosLicitacao(
                this.licitacao.idLicitacao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.documentosLicitacao = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDownload(doc) {
            this.$swal({
                title: 'Download',
                html: `Confirma o Download do Documento <b>${doc.descricaoArquivo}</b> ?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.download(doc)
                }
            })
        },

        download(doc) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadDocumentoLicitacao(
                this.licitacao.idLicitacao,
                doc.idDocumento
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro no Download!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, doc.vcNomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
